var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetidIcon80(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 70.6081,
    x2: 3.82649,
    y1: 69.2577,
    y2: 5.42232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01694,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30776,
    stopColor: "#009AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70553,
    stopColor: "#6B57FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M80.0001 0H0V80H80.0001V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 65H10V70H40V65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2144 9.78906H16.7212V39.7495H10.2144V9.78906Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.0581 9.78906H34.5933C43.8882 9.78906 50.311 16.252 50.311 24.6836V24.769C50.311 33.2012 43.8882 39.7495 34.5933 39.7495H23.0581V9.78906ZM29.565 15.7383V33.8003H34.5933C39.9165 33.8003 43.5083 30.1621 43.5083 24.855V24.769C43.5083 19.4619 39.9165 15.7383 34.5933 15.7383H29.565V15.7383Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetidIcon80);
export default __webpack_public_path__ + "static/media/jetid-icon-80.b6bdf040bd27d876e0e1c16f2eae62fa.svg";
export { ForwardRef as ReactComponent };